var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[(_vm.text==='Loading...')?_c('div',{staticClass:"anim-text"},[_c('span',[_vm._v("Loading")]),_c('span',{staticClass:"dot dot1"},[_vm._v(".")]),_c('span',{staticClass:"dot dot2"},[_vm._v(".")]),_c('span',{staticClass:"dot dot3"},[_vm._v(".")])]):_c('span',{staticClass:"custom-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }